import React from 'react';
import { RouteObject } from 'react-router';
import Home from './components/Home';
import Leaders from './components/Leaders';
import NotFound from './components/NotFound';
import Stats from './components/Stats';
import Talks from './components/Talks';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/leaders',
    element: <Leaders />,
  },
  {
    path: '/stats',
    element: <Stats />,
  },
  {
    path: '/talks',
    element: <Talks />,
  },
  {
    path: '/*',
    element: <NotFound />,
  },
];